import axios from 'axios';

const API_URL = process.env.REACT_APP_BASE_URL;

export const checkAuthStatus = async () => {
  const token = localStorage.getItem('token');
  
  if (!token) {
    return { isAuthenticated: false };
  }

  try {
    const response = await axios.get(`${API_URL}/api/auth/checkUserLogin`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    if (response.data.status === 200 && response.data.authenticated) {
      return {
        isAuthenticated: true,
        user: response.data.userData
      };
    }
    
    return { isAuthenticated: false };
  } catch (error) {
    console.error('Auth check failed:', error);
    // If token is invalid, clear it from storage
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('token');
    }
    return { isAuthenticated: false };
  }
};

export const logout = () => {
  localStorage.removeItem('token');
  window.location.href = '/home';
};
